import i18next from "i18next";
export default function SimulatedScorers({ data }) {
  if (!data) return null;
  const en = i18next.language?.startsWith("en"),
    fmt = (n) =>
      n == null
        ? "—"
        : n.toLocaleString(en ? "en" : "de", { maximumFractionDigits: 2 });
  return (
    <details
      style={{
        margin: "16px 0",
        padding: 12,
        border: "1px solid #657585",
        borderRadius: 8,
      }}
    >
      <summary>
        {en ? "Simulated goalscorers" : "Simulierte Torjäger"} · {data.runs}{" "}
        {en ? "runs" : "Durchläufe"}
      </summary>
      <p>
        {en
          ? "Heuristic simulation, not actual events. Tied leaders each count as title winners."
          : "Heuristische Simulation, keine tatsächlichen Ereignisse. Bei Gleichstand zählen alle Erstplatzierten als Titelgewinner."}
      </p>
      {data.partial && (
        <p>
          {en
            ? "Incomplete squad/actual-goal coverage. Title frequency unavailable."
            : "Unvollständige Kader-/Ist-Torabdeckung. Titelhäufigkeit nicht verfügbar."}
        </p>
      )}
      <p>
        {en
          ? "Unassigned simulated goals per run"
          : "Nicht zugeordnete simulierte Tore je Lauf"}
        : {fmt(data.unassigned)}
      </p>
      <div style={{ overflow: "auto", maxHeight: 360 }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              {(en
                ? [
                    "Player",
                    "Team",
                    "Actual",
                    "Simulated Ø",
                    "Total Ø",
                    "Top scorer %",
                  ]
                : [
                    "Spieler",
                    "Team",
                    "Tatsächlich",
                    "Simuliert Ø",
                    "Gesamt Ø",
                    "Torjägertitel %",
                  ]
              ).map((s) => (
                <th key={s}>{s}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((p) => (
              <tr key={`${p.teamId}:${p.playerId}`}>
                <td>{p.name}</td>
                <td>{p.teamName}</td>
                <td>{fmt(p.actualGoals)}</td>
                <td>{fmt(p.simulated)}</td>
                <td>{fmt(p.total)}</td>
                <td>
                  {fmt(
                    p.titleFrequency == null ? null : p.titleFrequency * 100
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}
